module.exports = __webpack_public_path__ + "img/mirror11.e3e2965d.jpg";